// src/autoParts.js
const autoParts = [
  
];

export default autoParts;
